'use strict';
const 	Localizer	= require('factories/Localizer');

module.exports = new Localizer([
	'modules/components/popup/login',
	function(){
		return require('./component')
	}
]);



// WEBPACK FOOTER //
// resources/modules/components/popup/login/localizer.jsx